var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-basic-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fInput),expression:"fInput"}],attrs:{"type":"text"},domProps:{"value":(_vm.fInput)},on:{"change":_vm.changed,"input":function($event){if($event.target.composing){ return; }_vm.fInput=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a2cf58c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/BasicInput.vue
// module id = null
// module chunks = 